import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as libraries from '../../../../libraries'
import * as estimate from '../estimate'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: estimate.RESOURCE.payload.dimension.partialId,
      partialId: estimate.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Library with which this FTE estimate is associated',
    isOptional: true,
    name: 'Library',
    partialId: PartialId.Standard.create('lib'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        libraries.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
